import { LucideIcon } from "lucide-react";

interface StatCardProps {
  title: string;
  value: string | number;
  subtitle?: string;
  icon: LucideIcon;
  variant?: "default" | "warning" | "success" | "info";
}

const variantStyles: Record<NonNullable<StatCardProps["variant"]>, string> = {
  default: "bg-primary-light text-primary-dark",
  warning: "bg-warning/10 text-warning",
  success: "bg-success/10 text-success",
  info: "bg-info/10 text-info",
};

export const StatCard = ({
  title,
  value,
  subtitle,
  icon: Icon,
  variant = "default",
}: StatCardProps) => (
  <div className="bg-card rounded-card border border-border p-5">
    <div className="flex items-start justify-between">
      <div>
        <p className="text-sm text-muted-foreground font-medium">{title}</p>
        <p className="text-2xl font-bold text-foreground mt-1">{value}</p>
        {subtitle && (
          <p className="text-xs text-muted-foreground mt-1">{subtitle}</p>
        )}
      </div>
      <div
        className={`w-10 h-10 rounded-btn flex items-center justify-center ${variantStyles[variant]}`}
      >
        <Icon className="w-5 h-5" />
      </div>
    </div>
  </div>
);

export default StatCard;
